module.exports = __webpack_public_path__ + "static/media/ntrip.76c9975c.png";